import { black, border1, textMuted } from '@/theme/colors'
import { fontBody, fontDisplay } from '@/theme/fonts'
import styled from 'styled-components'

/** Body column — used by the teaser (stat over lock line). */
export const MoneyBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	min-width: 0;
`

/** Public-teaser lock line under the anonymous summary. */
export const TeaserNote = styled.p`
	font-family: ${fontBody};
	font-size: 13.5px;
	line-height: 1.5;
	color: ${textMuted};
	margin: 0;
`

/** Horizontal hairline — separates the expense stat from the teaser lock line. */
export const MoneyDivider = styled.div`
	border-top: 1px solid ${border1};
	margin: 4px 0;
`

/** The two stats laid out side by side as equal columns. */
export const MoneyStats = styled.div`
	display: flex;
	align-items: stretch;
	gap: 16px;
	min-width: 0;
`

/** One stat column: a value with a muted count subtitle beneath it. */
export const StatBlock = styled.div`
	flex: 1;
	min-width: 0;
`

/** Vertical hairline between the two stat columns. */
export const StatDivider = styled.span`
	width: 1px;
	align-self: stretch;
	background: ${border1};
	flex-shrink: 0;
`

/**
 * Stat value (expense total / pay-up total). Around the flights tile's hero code
 * (21px/900) in size but lighter (700), so it reads as a stat within the bento's
 * type scale rather than shouting over it.
 */
export const StatValue = styled.div`
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: 24px;
	letter-spacing: -0.01em;
	line-height: 1.15;
	color: ${black};
`

/** Count subtitle under a stat value, e.g. "18 expenses". */
export const StatSub = styled.div`
	font-family: ${fontBody};
	font-size: 12.5px;
	color: ${textMuted};
	margin-top: 3px;
`
